import { TimeSeriesMeasurement } from '../../timeseries-statistics/model/TimeSeriesMeasurement.model';
import { Timestamp } from '../../timeseries-statistics/model/Timestamp.model';

export interface DeviceCpuMeasurementModel {
  time: Timestamp;
  cpuUsage: number;
}

export const mapDeviceCpuMeasurementModelToTimeSeriesMeasurement = (deviceCpuMeasurement: DeviceCpuMeasurementModel) : TimeSeriesMeasurement => ({
  time: new Date(deviceCpuMeasurement.time),
  value: deviceCpuMeasurement.cpuUsage
});